@if (events) {
  <div class="container container-images shadow rounded-top">
    <ngb-carousel>
      @for (item of events.data; track $index) {
        <ng-template ngbSlide>
          <div>
            <div class="picsum-img-wrapper">
              <img class="d-block w-100 event-image rounded" [src]="item.image" alt="Random first slide" />
            </div>
            <div class="bg-danger"></div>
            <div class="carousel-caption rounded-bottom">
              <h1>
                {{ item.title }} -
                <a href="{{ item.url }}" target="_blank" rel="noopener noreferrer">{{
                  "slider-events-call-to-action-home.details" | translate
                }}</a>
              </h1>
              <p class="p">{{ item.date }} - {{ item.hour }}</p>
              <p class="p mt-1 text-secondary">{{ item.location }}</p>
            </div>
          </div>
        </ng-template>
      } @empty {
        <h2>Não tem eventos cadastrados!</h2>
      }
    </ngb-carousel>
  </div>
}
